// Static content for TechnoVeda Solutions
import { Cpu, PenTool, Wrench, GraduationCap } from "lucide-react";

export const COMPANY = {
  name: "TechnoVeda Solutions",
  tagline: "Embedded Systems. Engineered with Depth.",
  intro:
    "We deliver a wide range of engineering trainings for both freshers and laterals in embedded system design and development — imparting in-depth knowledge with utmost efficiency, while sharpening soft skills and presentation confidence.",
  phone: "+91-9449066164",
  phoneHref: "tel:+919449066164",
  email: "sandeepsc.ece@gmail.com",
  emailHref: "mailto:sandeepsc.ece@gmail.com",
};

export const FOUNDER = {
  name: "Dr. Sandeep S Chapalkar",
  role: "Founder & CEO",
  domain: "Embedded Systems",
  photo: "/assets/founder.jpg",
  bio: "Driving TechnoVeda Solutions with deep expertise in embedded systems, Dr. Sandeep S Chapalkar leads consultation, design, development and hands-on training programs that turn engineers into confident, industry-ready professionals.",
  quote:
    "Great engineers aren't just taught to code — they're trained to think, communicate, and build with confidence.",
};

export const SERVICES = [
  {
    id: "consultation",
    icon: Cpu,
    title: "Consultation",
    desc: "Expert guidance on embedded architecture, feasibility, and technology selection for your product roadmap.",
  },
  {
    id: "design",
    icon: PenTool,
    title: "Design",
    desc: "Robust hardware-software co-design for microcontroller and IoT systems built to real-world constraints.",
  },
  {
    id: "development",
    icon: Wrench,
    title: "Development",
    desc: "End-to-end firmware and product development from bare-metal to Linux-based platforms.",
  },
  {
    id: "training",
    icon: GraduationCap,
    title: "Training",
    desc: "Structured, hands-on programs for freshers and laterals — technical depth plus soft-skill mastery.",
  },
];

export const TRAINING = [
  { category: "Languages", title: "C / C++ and Python programming" },
  { category: "Bare Metal", title: "Embedded C on ARM Cortex-M — Bare metal, CMSIS & HAL" },
  { category: "Architecture", title: "Embedded architecture and design" },
  { category: "Security", title: "Embedded security issues" },
  { category: "Linux", title: "Basics of Linux (Ubuntu)" },
  { category: "Scripting", title: "Shell scripting (bash)" },
  { category: "Hardware", title: "Arduino, Raspberry Pi, ESP32, PIC & more" },
];

export const PRODUCTS = [
  {
    title: "Speech Recognition & Subscriber Validation",
    desc: "Voice-based identity validation system built on Raspberry Pi.",
    status: "Delivered",
    span: "lg:col-span-8",
  },
  {
    title: "Public Alert System for Automobiles",
    desc: "Emergency alerting with real-time location identification.",
    status: "Delivered",
    span: "lg:col-span-4",
  },
  {
    title: "Water Plant Monitoring System",
    desc: "IoT and smart-device driven monitoring for water treatment plants.",
    status: "Delivered",
    span: "lg:col-span-4",
  },
  {
    title: "Industrial Plant Automation",
    desc: "Automation and monitoring solution for industrial plants.",
    status: "Delivered",
    span: "lg:col-span-8",
  },
  {
    title: "Ore Well Recovery Monitoring",
    desc: "Status monitoring for dry / failed ore well recovery operations.",
    status: "Under Development",
    span: "lg:col-span-6",
  },
  {
    title: "UPS-Enabled UV Sanitizer",
    desc: "Uninterrupted UV sanitization system for goods and packages.",
    status: "Under Development",
    span: "lg:col-span-6",
  },
];

export const STATS = [
  { value: "1000+", label: "Engineers Trained" },
  { value: "10+", label: "Years of Expertise" },
  { value: "6+", label: "Products Delivered" },
  { value: "4", label: "Core Service Streams" },
];

export const NAV_LINKS = [
  { id: "home", label: "Home", testid: "nav-home" },
  { id: "about", label: "About", testid: "nav-about" },
  { id: "services", label: "Services", testid: "nav-services" },
  { id: "training", label: "Training", testid: "nav-training" },
  { id: "products", label: "Products", testid: "nav-products" },
  { id: "contact", label: "Contact", testid: "nav-contact" },
];
